import { ForwardedRef, forwardRef } from 'react';
import { Typography } from '@material-ui/core';

import { useTitleStyles } from './Typography.styles';
import { TypographyProps } from './Typography.props';

export const Title = forwardRef(
  ({ className = '', ...props }: TypographyProps, ref: ForwardedRef<HTMLElement>): JSX.Element => {
    const styles = useTitleStyles();

    return <Typography classes={styles} className={className} {...props} {...{ ref }} />;
  },
);

Title.displayName = 'Typography.Title';
